import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AssetToolbar = ({
  viewMode,
  onViewModeChange,
  selectedCount,
  onUpload,
  onCreateFolder,
  onBulkDelete,
  onClearSelection
}) => {
  return (
    <div className="bg-card border-b border-border p-4">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
        <div className="flex items-center gap-2 flex-wrap">
          <Button
            variant="default"
            iconName="Upload"
            iconPosition="left"
            onClick={onUpload}
          >
            Upload Files
          </Button>
          <Button
            variant="outline"
            iconName="FolderPlus"
            iconPosition="left"
            onClick={onCreateFolder}
          >
            New Folder
          </Button>
        </div>

        {selectedCount > 0 && (
          <div className="flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-lg">
            <span className="caption font-medium text-primary">
              {selectedCount} selected
            </span>
            <Button
              variant="ghost"
              size="sm"
              iconName="Trash2"
              onClick={onBulkDelete}
            >
              Delete
            </Button>
            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              onClick={onClearSelection}
            >
              Clear
            </Button>
          </div>
        )}

        <div className="flex items-center gap-2 ml-auto">
          <button
            onClick={() => onViewModeChange('grid')}
            className={`p-2 rounded-lg transition-all duration-250 ${
              viewMode === 'grid' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
            aria-label="Grid view"
          >
            <Icon name="LayoutGrid" size={20} />
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`p-2 rounded-lg transition-all duration-250 ${
              viewMode === 'list' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:bg-muted hover:text-foreground'
            }`}
            aria-label="List view"
          >
            <Icon name="List" size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssetToolbar;